import Inventories from './Inventories';
import useInventories from './hooks/useInventories';
import useParamsInventory from './hooks/useParamsInventory';
import type Tabs from './interfaces/Tabs';

export {useInventories};
export {useParamsInventory};
export type {Tabs};
export default Inventories;
